import {
  African_LLMS_Img,
  Map_Overylay_Img,
  What_We_Do_Img,
} from "../../images";
import { useNavigate } from "react-router-dom";
import { CheckMark } from "../../icons";

export default function PoweringAI() {
  const navigate = useNavigate();
  const help = [
    "Source, clean and label Africa-specific datasets",
    "Evaluate & benchmark models",
    "Annotate models accurately",
    "Localise global models to African languages and contexts",
    "Deploy data agents & pipelines for continuous improvement",
  ];
  return (
    <section
      className="relative w-full bg-white py-[80px] md:py-[100px] bg-top bg-contain bg-no-repeat"
      style={{
        backgroundImage: `url("${Map_Overylay_Img}")`,
      }}
    >
      <div className="mx-auto container">
        <div className="h-[300px] w-[300px] xl:h-[450px] xl:w-[450px] bg-[#7AA8FF80] blur-[130px] absolute top-0 -left-[70%] md:-left-[45%] lg:-left-[15%]"></div>
        {/* Hero Header */}
        <div className="mb-10 md:mb-20 text-center relative z-[100]">
          <h1 className="mb-6 text-2xl font-bold tracking-tight md:text-[36px]">
            Powering AI with High-Quality{" "}
            <span className="text-[#0073FF]">African Data</span>
          </h1>
          <p className="mx-auto max-w-5xl font-medium text-sm sm:text-base md:text-lg xl:text-xl text-gray-700">
            We deliver high-quality, ethically sourced African data that powers
            the next generation of AI; globally aligned, locally grounded. From
            data annotation, labeling, and validation to large-scale evaluation,
            we build the datasets and insights that make AI work in Africa.
          </p>
        </div>

        {/* Featured Card Section */}
        <div className="mb-[32px] md:mb-[100px] flex flex-col-reverse items-center gap-8 md:grid md:gap-12 md:grid-cols-2 relative z-[100]">
          <img
            src={African_LLMS_Img}
            alt="Woman using mobile app"
            className="h-auto w-full max-w-[640px] object-cover"
          />

          {/* Right side with content */}
          <div className="space-y-6">
            <div className="space-y-4">
              <h2 className="text-lg md:text-2xl xl:text-[32px] font-bold !leading-[120%]">
                Bringing African Languages to the World (LLMs)
              </h2>
              <p className="text-sm sm:text-base md:text-lg xl:text-xl font-medium text-[#333333]">
                We are building large language models for low-resource African
                languages, transforming them into globally available digital
                assets. Our LLMs enable understanding, generation, and
                translation for continent-wide inclusion in the AI economy.
              </p>
            </div>

            <button
              className="bg-[#0073FF] py-3 text-base text-white font-semibold hover:bg-[#0073FF]/70 w-[170px] rounded-full"
              onClick={() => navigate("local-language-llms")}
            >
              Learn More
            </button>
          </div>
        </div>

        {/* What We Do Section */}
        <div className="grid items-center gap-12 md:grid-cols-2">
          {/* Left side - text content */}
          <div className="space-y-3 md:space-y-6">
            <div className="space-y-1 md:space-y-3">
              <h3 className=" text-2xl xl:text-[32px] font-bold">What We Do</h3>
              <p className="text-sm sm:text-base md:text-lg xl:text-xl font-medium text-[#333333]">
                Data, Powered by Intelligence
              </p>
            </div>
            <div className="space-y-3">
              <p className="font-bold text-sm sm:text-base md:text-lg xl:text-xl text-gray-900">
                We help you:
              </p>
              <ul className="space-y-2">
                {help.map((item, index) => (
                  <li
                    key={index}
                    className="text-sm md:text-base flex items-center gap-2 text-gray-700"
                  >
                    <CheckMark />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <img
            src={What_We_Do_Img}
            alt="Man working with data analytics"
            className="h-auto w-full max-w-[640px] object-cover"
          />
        </div>
      </div>
    </section>
  );
}
